import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ArrowLeft } from "lucide-react";
import { useContactForm } from "../../../hooks/useContactForm";
import ContactFormFields from "./ContactFormFields";

interface Contact {
  id: string;
  name: string;
  email?: string;
  phone?: string;
  company?: string;
  address?: string;
  notes?: string;
  status: string;
  created_at: string;
  updated_at: string;
}

interface ContactFormProps {
  contact: Contact | null;
  onClose: () => void;
  onSuccess: () => void;
}

const ContactForm = ({ contact, onClose, onSuccess }: ContactFormProps) => {
  const { formData, isSubmitting, handleInputChange, handleSubmit } = useContactForm({
    contact,
    onSuccess,
  });

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-4">
        <Button variant="ghost" onClick={onClose} className="flex items-center gap-2">
          <ArrowLeft className="h-4 w-4" />
          Back to Contacts
        </Button>
        <h1 className="text-2xl font-bold">
          {contact ? 'Edit Contact' : 'New Contact'}
        </h1>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Contact Information</CardTitle>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-6">
            <ContactFormFields
              formData={formData}
              onInputChange={handleInputChange}
            />

            <div className="flex justify-end space-x-2">
              <Button type="button" variant="outline" onClick={onClose}>
                Cancel
              </Button>
              <Button type="submit" disabled={isSubmitting}>
                {isSubmitting ? 'Saving...' : (contact ? 'Update Contact' : 'Create Contact')}
              </Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default ContactForm;